export const UPDATE_SELECTED_STATUS_FIELD = "UPDATE_SELECTED_STATUS_FIELD";
export const UPDATE_SELECTED_RACK_IPN = "UPDATE_SELECTED_RACK_IPN";
export const UPDATE_SELECTED_DEPARTMENT = "UPDATE_SELECTED_DEPARTMENT";
export const UPDATE_SELECTED_CATEGORY = "UPDATE_SELECTED_CATEGORY";
export const UPDATE_SELECTED_RACK_TYPE = "UPDATE_SELECTED_RACK_TYPE";
export const UPDATE_SELECTED_EXTERNAL_RACK_TYPE = "UPDATE_SELECTED_EXTERNAL_RACK_TYPE";
export const UPDATE_SELECTED_INTERNAL_RACK_TYPE = "UPDATE_SELECTED_INTERNAL_RACK_TYPE";
export const UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT";
export const UPDATE_SEARCH_FIELD_ERROR = "UPDATE_SEARCH_FIELD_ERROR";
export const UPDATE_CONFIGURE_OVERRIDE_MODAL = "UPDATE_CONFIGURE_OVERRIDE_MODAL";
export const UPDATE_DISCONNECT_UPCOMING_AFG_MODAL = "UPDATE_DISCONNECT_UPCOMING_AFG_MODAL";
export const UPDATE_SCROLL_ID = "UPDATE_SCROLL_ID";
export const UPDATE_DROPDOWN_LOADING = "UPDATE_DROPDOWN_LOADING";
export const UPDATE_LOAD_MORE_BUTTON_CLICKED = "UPDATE_LOAD_MORE_BUTTON_CLICKED";
export const UPDATE_AFG_DATA = "UPDATE_AFG_DATA";
export const UPDATE_DISCONNECT_AFG = "UPDATE_DISCONNECT_AFG";
export const UPDATE_AFG_TABLE_DATA = "UPDATE_AFG_TABLE_DATA";
export const UPDATE_SELECTED_ITEMS = "UPDATE_SELECTED_ITEMS";
export const UPDATE_PREFERENCES = "UPDATE_PREFERENCES";
export const UPDATE_TYPE = "UPDATE_TYPE";
export const UPDATE_CATEGORY_OPTIONS = "UPDATE_CATEGORY_OPTIONS";
export const UPDATE_RACK_IPN_OPTIONS = "UPDATE_RACK_IPN_OPTIONS";
export const UPDATE_EXTERNAL_RACK_TYPE_OPTIONS = "UPDATE_EXTERNAL_RACK_TYPE_OPTIONS";
export const UPDATE_INTERNAL_RACK_TYPE_OPTIONS = "UPDATE_INTERNAL_RACK_TYPE_OPTIONS";
export const UPDATE_DEPARTMENT_OPTIONS = "UPDATE_DEPARTMENT_OPTIONS";